export interface UserNameLike {
  firstName: string;
  lastName: string;
}

/**
 * Compares users by last name, then first name ("Last, First"), the order
 * user lists are displayed and searched in. Missing users sort first.
 */
export function compareUserNames(
  a: UserNameLike | null | undefined,
  b: UserNameLike | null | undefined,
): number {
  return sortName(a).localeCompare(sortName(b));
}

function sortName(user: UserNameLike | null | undefined): string {
  return user ? `${user.lastName}, ${user.firstName}` : '';
}
